import React from 'react';
import {
  FormInputText,
  FormInputSelect,
  FormInputCheckbox,
  FormInputSwitch,
  FormInputAutocomplete,
  FormInputSelectChip
} from 'components/common';

export default function Input (props) {
  const { input, ...propsInput } = props;

  if (!input) return <></>

  if (input === 'textField' || input === 'textArea') {
    return (
      <FormInputText
        { ...propsInput }
      />
    )
  } else if (input === 'select') {
    return (
      <FormInputSelect
        { ...propsInput }
      />
    )
  } else if (input === 'checkbox') {
    return (
      <FormInputCheckbox
        { ...propsInput }
      />
    )
  } else if (input === 'switch') {
    return (
      <FormInputSwitch
        { ...propsInput }
      />
    )
  } else if (input === 'autocomplete') {
    return (
      <FormInputAutocomplete
        { ...propsInput }
      />
    )
  } else if (input === 'selectChip') {
    return (
      <FormInputSelectChip
        { ...propsInput }
      />
    )
  } else {
    return <></>
  }
}
